import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";

export const retreiveQuote = httpsCallable(functions, "retreiveQuote_V2");
export const quoteOpenedNotificaiton = httpsCallable(
  functions,
  "quoteOpened_V2"
);
